import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import VERIFY_WHITELABELING_DOMAIN from './verifyWhitelabelingDomain.gql';

export function verifyWhitelabelingDomain({ workspaceId }: { workspaceId: string; }) {
  return gqlOperation(VERIFY_WHITELABELING_DOMAIN, { workspaceId });
}
